// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/hand.js';

import { paths } from '../generated/hand';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('hand', Original, paths);
